// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgStatUp = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.526 11.418a.75.75 0 0 1 1.004.052l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0v-6.19l-1.72 1.72a.75.75 0 0 1-1.06-1.06l3-3zM19.47 3.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0L12 7.06l-7.47 7.47a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0L15 7.94z"
    />
  </svg>
);
export const StatUpIcon = forwardRef(SvgStatUp);
